import { ROUTE_ROLES } from 'constants/app.constant';
import { lazy } from 'react';
import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR, STUDENT = ROUTE_ROLES.STUDENT;
export var ShRoutes = {
    getRoutes: function () { return [
        {
            path: SH_PATHS.courseAggregate,
            component: lazy(function () { return import(/* webpackChunkName: "SHCourseAggregatePage" */ 'reports/sh/components/pages/sh-course-aggregate/SHCourseAggregatePage'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-course-aggregate"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SH_PATHS.studentAssignmentView,
            component: lazy(function () { return import(/* webpackChunkName: "SHStudentAssignmentView" */ 'reports/sh/components/pages/sh-student-assignment-view/SHStudentAssignmentView'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-student-assignment-view"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SH_PATHS.studentProfile,
            component: lazy(function () { return import(/* webpackChunkName: "SHStudentProfile" */ 'reports/sh/components/pages/sh-student-profile/SHStudentProfile'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-student-profile"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SH_PATHS.dashboard,
            component: lazy(function () { return import(/* webpackChunkName: "SHDashboard" */ 'reports/sh/components/pages/sh-dashboard/SHDashboard'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-dashboard"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SH_PATHS.cpraStudentResults,
            component: lazy(function () { return import(/* webpackChunkName: "SHCPRAStudentResults" */ 'reports/sh/components/pages/sh-cpra/sh-cpra-student-results/SHCPRAStudentResults'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-cpra-student-results"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: STUDENT
        },
        {
            path: SH_PATHS.cpra,
            component: lazy(function () { return import(/* webpackChunkName: "SHCPRA" */ 'reports/sh/components/pages/sh-cpra/sh-cpra-dashboard/SHCPRA'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-cpra"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        },
        {
            path: SH_PATHS.cpraSelectAssignment,
            component: lazy(function () { return import(/* webpackChunkName: "SHCPRASelectAssignment" */ 'reports/sh/components/pages/sh-cpra/SHCPRASelectAssignment'); }),
            data: {
                analytics: {
                    pageType: ELSCommonUIConstants.analytics.pageTypes.performanceStats,
                    pageName: "".concat(analyticBaseConfig.edApp, ":sh-cpra-select-assignment"),
                    pageProductName: 'sh'
                }
            },
            isPrivate: true,
            roles: INSTRUCTOR
        }
    ]; }
};
